import { Button, Tooltip, Typography } from "antd";
import { CheckOutlined } from '@ant-design/icons';
const { Text } = Typography;
export const AddressHandler = ({ data, handleCopy, copied }) => {
    const accountNumberorAddress = data?.address;
    const shortAddress = `${accountNumberorAddress.substring(0, 8)}....${accountNumberorAddress.substring(accountNumberorAddress.length - 8)}`
    return (
        <td style={{ paddingRight: 25 }}>
            {!accountNumberorAddress && <div className='text-center text-whiteText'> -- </div>}
            {accountNumberorAddress && copied !== data?.id &&
                <Text key={data?.id} className="text-whiteText flex justify-between" copyable={{ text: accountNumberorAddress, onCopy: handleCopy(data?.id) }} options={{ format: 'text/plain' }} >
                    <span>{shortAddress}</span>
                </Text>}
            {copied === data?.id &&
                <Text className="text-whiteText flex justify-between" key={data?.id}>
                    <span>{shortAddress}</span>
                    <Tooltip title="Copied" open={copied}>
                        <CheckOutlined style={{ marginLeft: 8, color: 'green' }} />
                    </Tooltip>
                </Text>}
        </td>
    );
}
export const DepositHandler = ({ data, openModel }) => {
    return (
        <td>
            <Button className='cancel-btn py-1 px-2 h-9 !w-auto' onClick={openModel(data)}>Deposit</Button>
        </td>
    )
}